module.exports = __webpack_public_path__ + "static/media/air_ceiling.8c4b6039.png";